// extracted by mini-css-extract-plugin
export var editInput = "_eg-0";
export var editInputCompact = "_eg-2";
export var editInputLarge = "_eg-1";
export var editInputSmall = "_eg-3";